import * as React from 'react';
import { useSelector } from 'react-redux';
import { useAtomValue } from 'jotai';
import { Trend } from '@components/common';
import { currentMetricsMetaSelector, supportedMetricsSelector } from '@store/common/selectors';
import { useSupportedMetrics } from '@src/components/common/MetricSelectorPopup/hooks/useSupportedMetrics';
import { filterNAMetricsAtom } from '@src/atoms/page';
import { METRIC_SWITCH_MAP, getMetricDisplayName } from '@utils/metrics';
import {
  MetricsWidgetWrapper,
  WidgetNumberWrapper,
  MetricsCardTextWrapper,
  WidgetTitle,
} from '../styled';
import { getMetricTitle } from './improvement-opportunities-widget/utils';
import useSetSummaryExport from '../hooks/useSetSummaryExport';

const getTrend = (metricTotal, metricDodTotal) => {
  try {
    const trend = metricDodTotal ? (metricTotal - metricDodTotal) / metricDodTotal : null;
    return trend;
  } catch (e) {
    console.log(e);
  }
};

const MetricsWidget = ({
  data,
  dodData,
  selectedChartMetric,
  onWidgetCardClick,
  metricList,
  showTrend = false,
}) => {
  const allowedMetrics: Record<string, any> = useSupportedMetrics(
    useSelector(supportedMetricsSelector),
  );
  const metricsToNA: string[] = useAtomValue(filterNAMetricsAtom);

  const allowedMetricList = metricList.filter(
    (metric) =>
      (metric in allowedMetrics || METRIC_SWITCH_MAP[metric] in allowedMetrics) &&
      !metricsToNA.includes(metric),
  );

  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);

  useSetSummaryExport({
    totals: data,
    dodTotals: dodData,
    category: { name: 'Audience Metrics Summary', metrics: allowedMetricList },
  });

  return (
    // <MetricsWidgetWrapper>
    <>
      {allowedMetricList.map((metricKey) => {
        const displayName = getMetricDisplayName({ metricKey });
        return (
          <MetricsCardTextWrapper
            key={metricKey}
            onClick={() => onWidgetCardClick(metricKey, data?.[metricKey])}
            highlight={metricKey === selectedChartMetric}
          >
            <WidgetTitle>{displayName}</WidgetTitle>
            <WidgetNumberWrapper>
              {getMetricTitle(metricKey, data?.[metricKey])}
              {showTrend && (
                <Trend
                  value={getTrend(data?.[metricKey], dodData[metricKey])}
                  style={{ textAlign: 'left', paddingLeft: 4 }}
                  reverse={currentMetricsMeta?.[metricKey]?.reverse}
                />
              )}
            </WidgetNumberWrapper>
          </MetricsCardTextWrapper>
        );
      })}
      </>
    // </MetricsWidgetWrapper>
  );
};

export default MetricsWidget;
